import BubbleAndLine from "./components/BubbleAndLine";
import BubbleAndLine2 from "./components/BubbleAndLine2";
import BubbleAndLine3 from "./components/BubbleAndLine3";
import BubbleAndLine4 from "./components/BubbleAndLine4";
import BubbleAndLine5 from "./components/BubbleAndLine5";
import BubbleAndLine6 from "./components/BubbleAndLine6";
import BubbleAndLine7 from "./components/BubbleAndLine7";
import Graph2 from "./components/Graph2";
import ResultScreen from "./containers/ResultScreen";
import HomeScreen from "./containers/HomeScreen";
import './App.css';
import { useState } from "react";
import RotateModal from "./components/RotateModal"
import { withOrientationChange } from "react-device-detect";
import EvaluatorModal from "./components/EvaluatorModal";
function App(props) {
  const [qIndex, setQIndex] = useState(0)
  const [currentScreen, setCurrentScreen] = useState("Home");

  const { isPortrait, isLandscape, } = props;
  console.log("props: ", props);
  const [openPopup, setOpenPopup] = useState(true);
  const [modalOpen, setModalOpen] = useState(false)

  const handleReloadClick = () => {
    console.log('handleReloadClick')
    setModalOpen(false);
    // Update the qIndex state to trigger a re-render of the BubbleAndLine component
    setQIndex((prevQIndex) => prevQIndex + 1);
  };
  console.log("isPortrait", isPortrait, qIndex)
  console.log("isLandscape", isLandscape)
  return (
    <div className="App" style={{ fontFamily: "Rubik" }}>
      { !isPortrait &&
        <>
          {modalOpen && <EvaluatorModal handleReloadClick={handleReloadClick} />}
          {currentScreen === "Home" && <HomeScreen   setCurrentScreen={setCurrentScreen} />}
          { currentScreen === "Quiz" && qIndex === 0 && <BubbleAndLine qIndex={qIndex} setModalOpen={setModalOpen} /> }
          { currentScreen === "Quiz" && qIndex === 1 && <BubbleAndLine2 qIndex={qIndex} handleReloadClick={handleReloadClick}/> }
          { currentScreen === "Quiz" && qIndex === 2 && <BubbleAndLine3 qIndex={qIndex} handleReloadClick={handleReloadClick}/> }
          { currentScreen === "Quiz" && qIndex === 3 && <BubbleAndLine4 qIndex={qIndex} handleReloadClick={handleReloadClick}/> }
          { currentScreen === "Quiz" && qIndex === 4 && <BubbleAndLine5 qIndex={qIndex} handleReloadClick={handleReloadClick}/> }
          { currentScreen === "Quiz" && qIndex === 5 && <BubbleAndLine6 qIndex={qIndex} handleReloadClick={handleReloadClick}/> }
          { currentScreen === "Quiz" && qIndex === 6 && <BubbleAndLine7 qIndex={qIndex} setCurrentScreen={setCurrentScreen}/> }
          { currentScreen === "Result" && <ResultScreen  setCurrentScreen={setCurrentScreen} setQIndex={setQIndex}/> }
        </>
      }
      <RotateModal
        isOpen={isPortrait}
      />
    </div>
  );
}

export default withOrientationChange(App);
